var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-row-header bg-white sticky-top p-2 js-file-row-header"},[_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.truncatedPath))])])}
var staticRenderFns = []

export { render, staticRenderFns }